import React from "react"
import styled from 'styled-components';

const TermsPrivacyAndGDPRWrapper = styled.div`
.TermsPrivacyAndGDPR  {
  font-size: 14px;
  margin-top: -54px;
  a {
    background: 0 0;
    color: #4183C4;
    text-decoration: none;
  }  
  .container {
    margin-top: 64px;

    .content-container {
      padding: 1.85rem 2.45rem 1.5rem 2.45rem;
      word-wrap: break-word;
      text-align: justify;

      h1, h2, h3, h4, h5 {
        margin-bottom: 1rem;
        font-weight: 100;
      }

      h1 {
        font-size: 1.71428571rem;
        margin-bottom: 2rem;
      }

      h2 {
        font-size: 1.07142857rem;
      }

      h3 {
        font-size: 1rem;
        /*margin-left: 18px;*/
        margin-top: 0;
      }

      h4 {
        margin-top: 2rem;
      }

      h5 {
      }

      p {
        /*text-indent: 1.3rem;*/
        > em {
          margin-right: 0.6rem;
          /*margin-left*/: -0.7em;
        }
      }

      div.heading-paragraphs p {
        /*text-indent: 0;*/
      }

      ul {
        margin-left: 36px;
        li {
          list-style-type: disc;
        }
      }

      ol li {
        /*font-weight: bold;*/
        margin-bottom: 9px;
        list-style-type: decimal;

        > strong {
            /*margin-right: 0.8rem;*/
            font-weight: 600;
          }

        p {
          font-weight: normal;

          > strong {
            /*margin-right: 0.8rem;*/
            font-weight: 600;
          }

          &:first-child {
            /*text-indent: 0.5rem;*/
          }

          &:last-child {
            margin-bottom: 1em;
          }
        }

        h1, h2, h3, h4, h5 {
            /*margin-left: 18px;*/
          font-weight: bold;
        } 

      }

      ol[type='A'] li {
        list-style-type: upper-alpha;
      }

      h5:last-child {
        margin-top: 2.5rem; 
        margin-bottom: 0;

        i {
          color: rgba(0, 0, 0, .87);
        }
      }

  }
}
`;

export default TermsPrivacyAndGDPRWrapper;